import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FullscreenIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M2 7V2M2 2H7M2 2L8.25 8.25M22 7V2M22 2H17M22 2L15.75 8.25M2 17V22M2 22H7M2 22L8.25 15.75M22 22V17M22 22H17M22 22L15.75 15.75"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

FullscreenIcon.displayName = 'FullscreenIcon';
